import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environment';
import { map, Observable } from 'rxjs';
import { ConfigFilterResponse } from '../models';

@Injectable({
  providedIn: 'root',
})
export class ConfigFilterService {
  constructor(private http: HttpClient) {}

  public webConfigFilter(): Observable<ConfigFilterResponse> {
    const url = `${environment.service.host}/config/filter`;
    return this.http
      .post(url, {}, { responseType: 'text' })
      .pipe(map((_) => JSON.parse(_)));
  }
}
